import { format } from './number';

interface FormatMoneyArgs {
  fixed?: number; // 可选项：小数位数
  lowest?: number; // 可选项：最小金额阈值
}

interface FormatMoneyResult {
  localeStr: string;
  num: string;
  unit: string;
  sysmbol: string;
}

// 格式化金额函数
export function formatMoney(num = 0, args: FormatMoneyArgs | number = {}): FormatMoneyResult {
  const defaultLowest = 1e10; // 默认 10 亿
  let fixed = 2; // 默认保留两位小数
  let lowest: number = defaultLowest;

  // 如果 args 是对象，则解构出 fixed 和 lowest
  if (typeof args === 'object') {
    ({ fixed = 2, lowest = defaultLowest } = args);
  } else if (args !== undefined) {
    lowest = args; // 如果 args 不是对象，则认为是最低金额值
  }

  const sysmbol = '¥';

  // 如果 num 大于等于 10 亿
  if (num >= defaultLowest) {
    const localeStr = format(num / defaultLowest, 0);
    return {
      localeStr,
      num: localeStr,
      unit: '亿',
      sysmbol,
    };
  }

  // 如果 num 大于等于最低阈值
  if (num >= lowest) {
    const localeStr = format(num / lowest, 0);
    return {
      localeStr,
      num: localeStr,
      unit: '万',
      sysmbol,
    };
  }

  // 如果 num 小于最低阈值，保留固定的小数位
  const localeStr = format(num / 1e2, fixed);
  return {
    localeStr,
    num: localeStr,
    unit: '',
    sysmbol,
  };
}
